import { port_metrics_compar_actions, 
         port_tactical_actions,
         port_backtest_actions } from './ActionType';

export const PortMetricsCompar = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case port_metrics_compar_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case port_metrics_compar_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case port_metrics_compar_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case port_metrics_compar_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        default:
            return state;
    }
};

export const PortMetricsTactical = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case port_tactical_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case port_tactical_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case port_tactical_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case port_tactical_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        default:
            return state;
    }
};

export const PortBacktest = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case port_backtest_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case port_backtest_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case port_backtest_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case port_backtest_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        default:
            return state;
    }
};
